export default "__VITE_ASSET__mlulbq3S__"